<template>
  <el-container class="full-height bg-gray">
    <el-main class="page-content">
      <!-- 建议使用 router-view -->
      <keep-alive :include="cachedViews">
        <router-view class="res"></router-view>
      </keep-alive>
    </el-main>
  </el-container>
</template>

<script>
export default {
  computed: {
    cachedViews() {
      return this.$store.state.global.tagList
    }
  }
}
</script>

<style>

</style>
